import { useTranslation, Trans } from "react-i18next";

import {
  Container,
  ContentContainer,
  IntroContainer,
  IntroText,
  StyledButton,
  SuccessBackground01,
  SuccessBackground02,
  MainText,
  ShopifyLogo,
  SubText,
  StorePreviewImage,
  ArrowIcon,
} from "./styles";
import Modal from "~/components/ui/Modal";
import { SHOW_STORE_CUSTOMIZATION_MODAL } from "~/helpers/customEvents";
import { useModalTrigger } from "~/hooks/useModalTrigger";

type CustomizationStoreProps = {
  onContinue: () => void;
};

export const CustomizationStore = ({ onContinue }: CustomizationStoreProps) => {
  const { t } = useTranslation();
  const [isModalOpen] = useModalTrigger(SHOW_STORE_CUSTOMIZATION_MODAL, true);

  return (
    <Modal
      id="store-creation-initiated-success-modal"
      isShowing={isModalOpen}
      padding="24px"
      minWidth="min(90%, 482px)"
      overflow="hidden">
      <Container data-testid="onboarding-shopify-preparing-store-modal">
        <SuccessBackground01 />
        <SuccessBackground02 />
        <ContentContainer>
          <IntroContainer>
            <IntroText>
              {t("onboarding.customization-store.IntroText")}
            </IntroText>
          </IntroContainer>
          <MainText>
            <Trans
              i18nKey="onboarding.customization-store.MainText"
              components={{
                1: <ShopifyLogo />,
              }}
            />
          </MainText>
          <SubText>{t("onboarding.customization-store.SubText")}</SubText>
          <StyledButton
            title={t("onboarding.customization-store.Button.Title") as string}
            data-heap="onboarding-new-shopify-store-modal-reject-link"
            variant="default"
            onClick={() => {
              onContinue();
            }}>
            {t("onboarding.customization-store.Button.Label")}
            <ArrowIcon />
          </StyledButton>
          <StorePreviewImage />
        </ContentContainer>
      </Container>
    </Modal>
  );
};
